module.exports = __webpack_public_path__ + "img/home-lazer.6835f8cf.svg";